import React from "react";

export default function PasswordStrengthBar({ password }) {
    let label = "Too short";
    let level = 0;

    const len = password.length;

    if (len === 0) {
        label = "";
        level = 0;
    } else if (len <= 3) {
        label = "Too short"; level = 1;
    } else if (len <= 5) {
        label = "Weak"; level = 2;
    } else if (len === 6 || len === 7) {
        label = "Okay"; level = 3;
    } else if (len === 8 || len === 9) {
        label = "Good"; level = 4;
    } else if (len >= 10) {
        label = "Strong"; level = 5;
    }

    const colors = ["#eee", "#ff6b6b", "#ee8641ff", "#ffd24d", "#81cf53ff", "#2ecc71"];

    return (
        <div style={{ marginTop: 10 }}>
            <div style={{ display: "flex", gap: 6, marginBottom: 5 }}>
                {[1, 2, 3, 4, 5].map((i) => (
                    <div
                        key={i}
                        style={{
                            flex: 1,
                            height: 2,
                            borderRadius: 4,
                            backgroundColor: i <= level ? colors[level] : "#eee",
                            transition: "background-color 180ms ease",
                        }}
                    />
                ))}
            </div>
            <span style={{ fontSize: 14, color: "#d4c8c8ff" }}>{label}</span>
        </div>
    );
}
